import {useMemo} from 'react';

import {ELocationStateKey, useAppHistory} from 'shared/hooks/use-app-history';
import {useAppSelector} from 'store/config/hooks';
import {
    selectTableReportQueryParams,
} from 'store/slices/table-report-slice/table-report-query-params/table-report-query-params-selectors';
import {ETableReportChildDataSourceType} from 'store/slices/table-report-slice/table-report-slice-types';

export const useTableReportParameters = () => {
    const history = useAppHistory();

    const passedDrilldownParams = history.getLocationStateValue(ELocationStateKey.TABLE_REPORT_PARAMS);
    const passedDocJournalWidgetParams = history.getLocationStateValue(ELocationStateKey.AIS_DOCUMENT_JOURNAL_PIE_CART);
    const requestGeneralParams = history.getLocationStateValue(ELocationStateKey.TABLE_REPORT_REQUEST_GENERAL_PARAMS);
    const customCrRequestParams = history.getLocationStateValue(ELocationStateKey.TABLE_REPORT_CUSTOM_CR_PARAMS);

    const {
        drillId,
        drillParameters,
    } = passedDrilldownParams ?? {};

    const drillParametersForFilter = useMemo(() => Object
        .fromEntries((drillParameters ?? [])
            .filter(param => param.childDataSourceType === ETableReportChildDataSourceType.PARAMETER)
            .map(param => ([param.childParameterName, param.value]))),
    [drillParameters]);

    const queryParametersInStore = useAppSelector(selectTableReportQueryParams);

    const isDrillDownParameterUsedInFilter = (paramName: string) => Object.keys(
        drillParametersForFilter,
    ).includes(paramName);

    const parameters = useMemo(() => {
        const passedParameters = {
            DRILL_ID: drillId,
        };

        return {
            parameters: queryParametersInStore,
            drillParameters, // параметры дрилла из родителя (не все применяются в фильтре в шапке)
            drillParametersForFilter, // параметры из дрила, которые нужно применить в фильтре в шапке
            passedParameters, // остальные полученные из LocationState параметры (id дрилла и другие при необходимости)
            passedDocJournalWidgetParams: passedDocJournalWidgetParams ?? {},
            isDrillDownParameterUsedInFilter,
            requestGeneralParams,
            customCrRequestParams: !drillId ? customCrRequestParams : undefined,
        };
    }, [queryParametersInStore, passedDrilldownParams, requestGeneralParams, customCrRequestParams]);

    return {
        ...parameters,
    };
};
